import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ActiveStepState {
  step: number;
  setStep: (step: number) => void;
  subStepsCompleted: Record<number, boolean[]>;
  markSubStepComplete: (step: number, subStepIndex: number) => void;
}

export const ActiveStepStore = create<ActiveStepState>()(
  persist(
    (set, get) => ({
      step: 0,
      setStep: (newStep) => set({ step: newStep }),
      subStepsCompleted: {
        3: [false, false],
      },
      markSubStepComplete: (step, index) => {
        const current = get().subStepsCompleted[step] ?? [];
        const updated = [...current];
        updated[index] = true;
        set({
          subStepsCompleted: {
            ...get().subStepsCompleted,
            [step]: updated,
          },
        });
      },
    }),
    {
      name: "activeStep",
      getStorage: () => localStorage,
      partialize: (state) => ({
        step: state.step,
        subStepsCompleted: state.subStepsCompleted,
      }),
    },
  ),
);
